module.exports = __webpack_public_path__ + "resources/img/solution_finance_cloud3.b670c61dbd2bdfe2f4b3fa0bdab0efef.png";